import React from "react";

const Contact = () => {
    return (
        <footer class="bg-gray-100 h-screen flex justify-center items-center">
            <div class="container mx-auto px-6 pt-10 pb-6">
                <div class="flex flex-wrap">
                    <div class="w-full md:w-1/4 text-center md:text-left">
                        <h5 class=" uppercase text-blue-500 mb-6 font-bold text-xl">Links</h5>
                        <ul class="mb-4">
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    FAQ
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Help
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Support
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="w-full md:w-1/4 text-center md:text-left">
                        <h5 class=" uppercase text-blue-500 mb-6 font-bold text-xl">Legal</h5>
                        <ul class="mb-4">
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Terms
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Privacy
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="w-full md:w-1/4 text-center md:text-left">
                        <h5 class=" uppercase text-blue-500 mb-6 font-bold text-xl">Social</h5>
                        <ul class="mb-4">
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Facebook
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Linkedin
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Twitter
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="w-full md:w-1/4 text-center md:text-left">
                        <h5 class=" uppercase text-blue-500 mb-6 font-bold text-xl">Company</h5>
                        <ul class="mb-4">
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Official Blog
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    About Us
                                </a>
                            </li>
                            <li class="mt-2">
                                <a
                                    href="#"
                                    class="hover:underline text-gray-900 hover:text-blue-500 "
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Contact;
